export default "__VITE_ASSET__B4q77plF__"